import { v4 as uuid } from 'uuid';
// import { supistaAnalyticsApi, supistaApiPost } from "lib/data-connectors/dependencies/connections";
// import getAppID from 'utils/getAppID';
import { publishToProduction } from 'lib/data-connectors/dependencies/publishToProductions';
// import { fetchDataToPlot } from 'app/network/apiConnections';
import reduxConstants from 'lib/reusable-components/reusableUtils/redux/reduxConstants';
import { create } from 'lib/reusable-components/reusableUtils/redux/stateSlice';
import { useDispatch } from 'react-redux';
import { _fetchDataToPlot, _supistaAnalyticsApi, _supistaApiPost } from 'lib/server-connection/connections';


function useSampleDatabase() {
  const dispatch = useDispatch();

  return async (appID) => {
    const credentialID = uuid();
    const currentTimestamp = Date.now();

    await _supistaAnalyticsApi(`${appID}/api/createCredentials/fetch`, {
        appID: appID,
        credentialID: credentialID,
        connectionName: "Sample Google Sheet",
        description: "This is sample data source from where we will be creating new charts using AI.",
        refreshInterval: "3",
        connectorType: "__d3__googleSheets",
        data: {
            spreadsheetID: "1_41dq-19r6qCiI1UFSA80nps0vHL3g5i2wOPS6hUepU",
        }
    });

    const productsTableData = {
        "data": {
            "name": "Products",
            "columnSchema": [
                {
                    "columnName": "Product ID",
                    "dataType": "number",
                    "name": "Product ID"
                },
                {
                    "columnName": "Product Name",
                    "dataType": "text",
                    "name": "Product Name"
                },
                {
                    "columnName": "Product Category",
                    "dataType": "text",
                    "name": "Product Category"
                },
                {
                    "columnName": "Price",
                    "dataType": "number",
                    "name": "Price"
                }
            ],
            "description": "",
            "tableID": "Products",
            appID,
            "dbType": "__d3__googleSheets",
            "credentialID": credentialID,
            "updates": {
                "addColumns": [],
                "updateColumns": [],
                "deleteColumns": [],
                "renameColumns": {},
                "dropTable": false,
                "createTable": true
            },
            "createdAt": currentTimestamp,
            "updatedAt": currentTimestamp,
        }
    };
    await _supistaApiPost(`settings/${appID}/DataTable`, productsTableData)


    const SalesTableData = {
        "data": {
            "name": "Sales",
            "columnSchema": [
                {
                    "columnName": "Date Sold",
                    "dataType": "date",
                    "name": "Date Sold"
                },
                {
                    "columnName": "Product ID",
                    "dataType": "number",
                    "name": "Product ID"
                },
                {
                    "columnName": "Amount",
                    "dataType": "number",
                    "name": "Amount"
                },
                {
                    "columnName": "Units Sold",
                    "dataType": "number",
                    "name": "Units Sold"
                },
                {
                    "columnName": "Region of Buyer",
                    "dataType": "text",
                    "name": "Region of Buyer"
                },
                {
                    "columnName": "Profit",
                    "dataType": "number",
                    "name": "Profit"
                }
            ],
            "description": "",
            "tableID": "Sales",
            "appID": appID,
            "dbType": "__d3__googleSheets",
            "credentialID": credentialID,
            "updates": {
                "addColumns": [],
                "updateColumns": [],
                "deleteColumns": [],
                "renameColumns": {},
                "dropTable": false,
                "createTable": true
            },
            "createdAt": currentTimestamp,
            "updatedAt": currentTimestamp
        }
    };
    await _supistaApiPost(`settings/${appID}/DataTable`, SalesTableData);

    const productSalesJoinTableData = {
        "data": {
            appID,
            "name": "Product Sales Data",
            "tableID": "Product Sales Data",
            "tableType": "JOINED_TABLE",
            "tables": [
                "Sales",
                "Products"
            ],
            "columnSchema": [
                {
                    "name": "Date Sold",
                    "columnName": "Date Sold",
                    "dataType": "date"
                },
                {
                    "name": "Product ID",
                    "columnName": "Product ID",
                    "dataType": "number"
                },
                {
                    "name": "Amount",
                    "columnName": "Amount",
                    "dataType": "number"
                },
                {
                    "name": "Units Sold",
                    "columnName": "Units Sold",
                    "dataType": "number"
                },
                {
                    "name": "Region of Buyer",
                    "columnName": "Region of Buyer",
                    "dataType": "text"
                },
                {
                    "name": "Profit",
                    "columnName": "Profit",
                    "dataType": "number"
                }
            ],
            "primaryTable": "Sales",
            "joinTableSchema": [
                {
                    "joinTableName": "Products",
                    "columnSchema": [
                        {
                            "name": "Product ID",
                            "columnName": "Product ID",
                            "dataType": "number"
                        },
                        {
                            "name": "Product Name",
                            "columnName": "Product Name",
                            "dataType": "text"
                        },
                        {
                            "name": "Product Category",
                            "columnName": "Product Category",
                            "dataType": "text"
                        },
                        {
                            "name": "Price",
                            "columnName": "Price",
                            "dataType": "number"
                        }
                    ],
                    "primaryKey": "Product ID",
                    "primaryTable": "Sales",
                    "secondaryKey": "Product ID"
                }
            ],
            "updatedAt": currentTimestamp,
            "createdAt": currentTimestamp
        }
    };
    
    await _supistaApiPost(`settings/${appID}/JoinTable`, productSalesJoinTableData);

    await publishToProduction(appID);

    const res = await _fetchDataToPlot({ appID }, `${appID}/allSchema`);
        if (res.__d3__error !== true) {
            dispatch(
            create({
                setPath: reduxConstants.config.ANALYTICS_SCHEMA,
                value: res.response,
            })
            );
        }
    };
}

export default useSampleDatabase;
